import { render, staticRenderFns } from "./PolygonModal.vue?vue&type=template&id=3536f76c&scoped=true"
import script from "./PolygonModal.vue?vue&type=script&lang=js"
export * from "./PolygonModal.vue?vue&type=script&lang=js"
import style0 from "./PolygonModal.vue?vue&type=style&index=0&id=3536f76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536f76c",
  null
  
)

export default component.exports